import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-reduce-time",
  "use": "app-icon-reduce-time-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"app-icon-reduce-time\"><path d=\"M7.464 6.515v-1.49a.47.47 0 11.94 0v1.488a.94.94 0 01.469.73h2.367a.47.47 0 110 .94H8.405c-.024 0-.047 0-.07-.002a.94.94 0 01-.87-1.665zm6.744.948a6.112 6.112 0 01-12.188 0H.593a.47.47 0 010-.94H2.02a6.112 6.112 0 0112.188 0h1.43a.47.47 0 010 .94h-1.429zm-.921-.47a5.172 5.172 0 10-10.344 0 5.172 5.172 0 0010.344 0z\" fill=\"#666\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol